import { gql } from "@apollo/client";

export const GET_SUBURB = gql`
  query GetSuburb {
    getSuburb {
      count
      currentPage
      message
      nextPage
      prevPage
      success
      totalPages
      result {
        cityId
        suburbId
        suburbName
        createdBy
        createdDate
        isActive
        modifiedBy
        modifiedDate
        include
      }
    }
  }
`